import type { DtActionsAtom } from '@/components/pages/backoffice/_klb-penyuluh/_kecamatan/state/atoms'
import type {
  ServiceGetAllResponse,
  ServiceGetByIdResponse,
  ServiceMutationOptionType,
  ServiceQueryOptionType
} from '@/types/service'

import { api, handleAxiosError } from '@/lib/axios'

import type { FotoBangunanDataType } from './types'
import type { MutationFotoBangunanValues } from './validations'

const QUERY_KEY = (key?: string | Record<string, any>) => ['foto', key] as const

const getAll = (
  params?: DtActionsAtom
): ServiceQueryOptionType<
  ServiceGetAllResponse<Array<FotoBangunanDataType>>
> => ({
  queryKey: QUERY_KEY(params),
  queryFn: async () => {
    try {
      const response = await api.get<
        ServiceGetAllResponse<Array<FotoBangunanDataType>>
      >(`kelembagaan/bpp/${params?.id_bpp}/foto`, {
        params: {
          page: params?.page,
          per_page: params?.perPage || undefined
        }
      })

      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

const create = (): ServiceMutationOptionType<
  ServiceGetByIdResponse<FotoBangunanDataType>,
  MutationFotoBangunanValues
> => ({
  mutationKey: QUERY_KEY(undefined),
  mutationFn: async (data: MutationFotoBangunanValues) => {
    try {
      const formData = new FormData()
      if (data.id_bpp) formData.append('id_bpp', data.id_bpp)
      // if (data._method) formData.append('_method', data._method)
      if (data.tampak_depan) formData.append('tampak_depan', data.tampak_depan)
      if (data.tampak_belakang)
        formData.append('tampak_belakang', data.tampak_belakang)
      if (data.tampak_dalam) formData.append('tampak_dalam', data.tampak_dalam)
      if (data.tampak_samping)
        formData.append('tampak_samping', data.tampak_samping)
      if (data.lahan_percontohan)
        formData.append('lahan_percontohan', data.lahan_percontohan)

      const response = await api.post(
        `kelembagaan/bpp/${data.id_bpp ?? ''}/foto`,
        formData
      )
      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

const deleteData = (): ServiceMutationOptionType<
  void,
  { id_bpp: string; id_foto: string }
> => ({
  mutationFn: async (data: { id_bpp: string; id_foto: string }) => {
    try {
      const response = await api.delete(
        `kelembagaan/bpp/${data.id_bpp}/foto/${data.id_foto}`
      )
      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

export const fotoBangunan = {
  queryKey: [QUERY_KEY(undefined)[0]],
  getAll,
  create,
  deleteData
}
